import { useTranslation } from 'react-i18next';
import Alert from '../../styled-components/components/Alert';
import Container from '../../styled-components/components/Container';
import { H1 } from '../../styled-components/components/Heading';

const ErrorFetchingBranches = () => {
  const { t } = useTranslation(['authentication']);
  return (
    <Container>
      <H1>{t('errorFetchingBranches.heading', { ns: 'authentication' })}</H1>
      <Alert tone="error" message={t('errorFetchingBranches.message', { ns: 'authentication' })} />
    </Container>
  );
};

export default ErrorFetchingBranches;
